"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalEventServiceReleaseSeatResponse = exports.PortalEventServiceReleaseSeatRequest = exports.PortalEventServiceAssignSeatResponse = exports.PortalEventServiceAssignSeatRequest = exports.PortalEventServiceReserveSeatResponse = exports.PortalEventServiceReserveSeatRequest = exports.PortalEventServiceGetTicketAvailableConsecutiveCountResponse = exports.PortalEventServiceGetTicketAvailableConsecutiveCountRequest = exports.PortalEventServiceGetTicketsBonusMediaResponse = exports.PortalEventServiceGetTicketsBonusMediaRequest = exports.PortalEventServiceGetEventsByBrandIdResponse = exports.PortalEventServiceGetEventsByBrandIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetEventsByBrandIdRequest
 */
class PortalEventServiceGetEventsByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetEventsByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetEventsByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetEventsByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetEventsByBrandIdRequest, a, b);
    }
}
exports.PortalEventServiceGetEventsByBrandIdRequest = PortalEventServiceGetEventsByBrandIdRequest;
PortalEventServiceGetEventsByBrandIdRequest.runtime = protobuf_1.proto3;
PortalEventServiceGetEventsByBrandIdRequest.typeName = "spwn.event.v1.PortalEventServiceGetEventsByBrandIdRequest";
PortalEventServiceGetEventsByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetEventsByBrandIdResponse
 */
class PortalEventServiceGetEventsByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.PortalEvent events = 1;
         */
        this.events = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetEventsByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetEventsByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetEventsByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetEventsByBrandIdResponse, a, b);
    }
}
exports.PortalEventServiceGetEventsByBrandIdResponse = PortalEventServiceGetEventsByBrandIdResponse;
PortalEventServiceGetEventsByBrandIdResponse.runtime = protobuf_1.proto3;
PortalEventServiceGetEventsByBrandIdResponse.typeName = "spwn.event.v1.PortalEventServiceGetEventsByBrandIdResponse";
PortalEventServiceGetEventsByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: portal_common_pb_1.PortalEvent, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetTicketsBonusMediaRequest
 */
class PortalEventServiceGetTicketsBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated string ticket_ids = 2;
         */
        this.ticketIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetTicketsBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetTicketsBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetTicketsBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetTicketsBonusMediaRequest, a, b);
    }
}
exports.PortalEventServiceGetTicketsBonusMediaRequest = PortalEventServiceGetTicketsBonusMediaRequest;
PortalEventServiceGetTicketsBonusMediaRequest.runtime = protobuf_1.proto3;
PortalEventServiceGetTicketsBonusMediaRequest.typeName = "spwn.event.v1.PortalEventServiceGetTicketsBonusMediaRequest";
PortalEventServiceGetTicketsBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetTicketsBonusMediaResponse
 */
class PortalEventServiceGetTicketsBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.PortalTicketBonusMedia ticket_bonus_media = 1;
         */
        this.ticketBonusMedia = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetTicketsBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetTicketsBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetTicketsBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetTicketsBonusMediaResponse, a, b);
    }
}
exports.PortalEventServiceGetTicketsBonusMediaResponse = PortalEventServiceGetTicketsBonusMediaResponse;
PortalEventServiceGetTicketsBonusMediaResponse.runtime = protobuf_1.proto3;
PortalEventServiceGetTicketsBonusMediaResponse.typeName = "spwn.event.v1.PortalEventServiceGetTicketsBonusMediaResponse";
PortalEventServiceGetTicketsBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_bonus_media", kind: "message", T: portal_common_pb_1.PortalTicketBonusMedia, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetTicketAvailableConsecutiveCountRequest
 */
class PortalEventServiceGetTicketAvailableConsecutiveCountRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string ticket_id = 2;
         */
        this.ticketId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetTicketAvailableConsecutiveCountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetTicketAvailableConsecutiveCountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetTicketAvailableConsecutiveCountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetTicketAvailableConsecutiveCountRequest, a, b);
    }
}
exports.PortalEventServiceGetTicketAvailableConsecutiveCountRequest = PortalEventServiceGetTicketAvailableConsecutiveCountRequest;
PortalEventServiceGetTicketAvailableConsecutiveCountRequest.runtime = protobuf_1.proto3;
PortalEventServiceGetTicketAvailableConsecutiveCountRequest.typeName = "spwn.event.v1.PortalEventServiceGetTicketAvailableConsecutiveCountRequest";
PortalEventServiceGetTicketAvailableConsecutiveCountRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetTicketAvailableConsecutiveCountResponse
 */
class PortalEventServiceGetTicketAvailableConsecutiveCountResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 count = 1;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetTicketAvailableConsecutiveCountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetTicketAvailableConsecutiveCountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetTicketAvailableConsecutiveCountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetTicketAvailableConsecutiveCountResponse, a, b);
    }
}
exports.PortalEventServiceGetTicketAvailableConsecutiveCountResponse = PortalEventServiceGetTicketAvailableConsecutiveCountResponse;
PortalEventServiceGetTicketAvailableConsecutiveCountResponse.runtime = protobuf_1.proto3;
PortalEventServiceGetTicketAvailableConsecutiveCountResponse.typeName = "spwn.event.v1.PortalEventServiceGetTicketAvailableConsecutiveCountResponse";
PortalEventServiceGetTicketAvailableConsecutiveCountResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceReserveSeatRequest
 */
class PortalEventServiceReserveSeatRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * @generated from field: string order_id = 2;
         */
        this.orderId = "";
        /**
         * @generated from field: repeated spwn.event.v1.SeatReserveItem items = 3;
         */
        this.items = [];
        /**
         * @generated from field: bool allow_non_consecutive = 4;
         */
        this.allowNonConsecutive = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceReserveSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceReserveSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceReserveSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceReserveSeatRequest, a, b);
    }
}
exports.PortalEventServiceReserveSeatRequest = PortalEventServiceReserveSeatRequest;
PortalEventServiceReserveSeatRequest.runtime = protobuf_1.proto3;
PortalEventServiceReserveSeatRequest.typeName = "spwn.event.v1.PortalEventServiceReserveSeatRequest";
PortalEventServiceReserveSeatRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "items", kind: "message", T: portal_common_pb_1.SeatReserveItem, repeated: true },
    { no: 4, name: "allow_non_consecutive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceReserveSeatResponse
 */
class PortalEventServiceReserveSeatResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool reserved = 1;
         */
        this.reserved = false;
        /**
         * @generated from field: spwn.event.v1.SeatUnavailableReason reason = 2;
         */
        this.reason = portal_common_pb_1.SeatUnavailableReason.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceReserveSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceReserveSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceReserveSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceReserveSeatResponse, a, b);
    }
}
exports.PortalEventServiceReserveSeatResponse = PortalEventServiceReserveSeatResponse;
PortalEventServiceReserveSeatResponse.runtime = protobuf_1.proto3;
PortalEventServiceReserveSeatResponse.typeName = "spwn.event.v1.PortalEventServiceReserveSeatResponse";
PortalEventServiceReserveSeatResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reserved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "reason", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.SeatUnavailableReason) },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceAssignSeatRequest
 */
class PortalEventServiceAssignSeatRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * @generated from field: string order_id = 2;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceAssignSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceAssignSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceAssignSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceAssignSeatRequest, a, b);
    }
}
exports.PortalEventServiceAssignSeatRequest = PortalEventServiceAssignSeatRequest;
PortalEventServiceAssignSeatRequest.runtime = protobuf_1.proto3;
PortalEventServiceAssignSeatRequest.typeName = "spwn.event.v1.PortalEventServiceAssignSeatRequest";
PortalEventServiceAssignSeatRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceAssignSeatResponse
 */
class PortalEventServiceAssignSeatResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceAssignSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceAssignSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceAssignSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceAssignSeatResponse, a, b);
    }
}
exports.PortalEventServiceAssignSeatResponse = PortalEventServiceAssignSeatResponse;
PortalEventServiceAssignSeatResponse.runtime = protobuf_1.proto3;
PortalEventServiceAssignSeatResponse.typeName = "spwn.event.v1.PortalEventServiceAssignSeatResponse";
PortalEventServiceAssignSeatResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.PortalEventServiceReleaseSeatRequest
 */
class PortalEventServiceReleaseSeatRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * @generated from field: string order_id = 2;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceReleaseSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceReleaseSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceReleaseSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceReleaseSeatRequest, a, b);
    }
}
exports.PortalEventServiceReleaseSeatRequest = PortalEventServiceReleaseSeatRequest;
PortalEventServiceReleaseSeatRequest.runtime = protobuf_1.proto3;
PortalEventServiceReleaseSeatRequest.typeName = "spwn.event.v1.PortalEventServiceReleaseSeatRequest";
PortalEventServiceReleaseSeatRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceReleaseSeatResponse
 */
class PortalEventServiceReleaseSeatResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceReleaseSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceReleaseSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceReleaseSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceReleaseSeatResponse, a, b);
    }
}
exports.PortalEventServiceReleaseSeatResponse = PortalEventServiceReleaseSeatResponse;
PortalEventServiceReleaseSeatResponse.runtime = protobuf_1.proto3;
PortalEventServiceReleaseSeatResponse.typeName = "spwn.event.v1.PortalEventServiceReleaseSeatResponse";
PortalEventServiceReleaseSeatResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
//# sourceMappingURL=portal_service_pb.js.map